module.exports = __webpack_public_path__ + "static/media/Future-money.9aa1a91c.png";